$('[href$=".pdf"]').attr('target', '_blank');